/* ---------------------------------------------------------------------------
   STL 2026 — G6  Notify Me -> Amp Back in Stock

   Serena, 13 Sep 2026: the out-of-stock CTA opens Amp's back-in-stock form, on the
   PDP and in the mobile quick-add sheet. The app embed ("Back in stock helper") is
   switched on, so Amp's widget script is on every page and exposes `window.BIS`.

   WHY NOT AMP'S DOCUMENTED `id="BIS_trigger"`. Amp's product-page handler only
   exists on a product URL and only for THAT product (`BIS.popup`), and it matches
   by element id — so it cannot serve the quick-add sheet, where one PLP carries a
   sheet per card for many products. Amp's own generic path (the one it binds when
   `generic_trigger_handler` is on, which it is for this shop) builds a popover per
   product handle with `BIS.createPopover({ productHandle })` and opens it with
   `form.show({ variantId })`. This file calls that same path directly, so both
   surfaces behave identically and nothing depends on ids being unique.

   Madrid's Notify Me button is left in place (and its styling with it); a
   capture-phase click listener takes the click before Madrid's <modal-opener>
   sees it. IF AMP IS NOT ON THE PAGE the click is not taken, so Madrid's own
   notification modal still opens rather than the button going dead.
   ------------------------------------------------------------------------- */
(function () {
  'use strict';

  if (window.stlBackInStockLoaded) return;
  window.stlBackInStockLoaded = true;

  var popovers = {};

  function amp() {
    return window.BIS && typeof window.BIS.createPopover === 'function' ? window.BIS : null;
  }

  function handleFromUrl() {
    var m = decodeURIComponent(window.location.pathname).match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function popoverFor(handle) {
    var bis = amp();
    if (!bis || !handle) return null;
    /* On the product's own page Amp has already built and loaded a popover for it —
       reuse that rather than fetching the product a second time. */
    if (bis.popup && handleFromUrl() === handle) return bis.popup;
    if (!popovers[handle]) {
      popovers[handle] = bis.createPopover({ productHandle: handle, button: { visible: false } });
    }
    return popovers[handle];
  }

  /* Returns true when Amp took the request, so the caller can cancel its fallback. */
  function openNotify(handle, variantId) {
    var pop = popoverFor(handle);
    if (!pop || !pop.ready || typeof pop.ready.then !== 'function') return false;
    try {
      pop.ready.then(function () {
        var show = function () { pop.form.show({ variantId: variantId ? String(variantId) : undefined }); };
        if (window.BIS && typeof window.BIS.defer === 'function') window.BIS.defer(13, show);
        else setTimeout(show, 13);
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  window.stlOpenBackInStock = openNotify;

  /* PDP. The button renders inside `#notify-button-{section id}`, and the selected
     variant is the hidden `id` input of `#product-form-{section id}`, which
     Madrid keeps current on every size change. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.notify-open-button');
    if (!button) return;

    var wrapper = button.closest('[id^="notify-button-"]');
    var sectionId = wrapper ? wrapper.id.replace('notify-button-', '') : null;
    var form = sectionId ? document.getElementById('product-form-' + sectionId) : null;
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var handle = button.getAttribute('data-stl-product-handle') || handleFromUrl();

    if (openNotify(handle, idInput ? idInput.value : null)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
})();
